module.exports = __webpack_public_path__ + "img/play_button.556b7b5e.png";